/**
 * This class is used to spy on the document.execCommand
 * This class will be excluded from test coverage
 */
export const execCommand = (command: string) => {
  document.execCommand(command);
};

export default execCommand;
